module.exports = __webpack_public_path__ + "static/media/NoirPro-Regular.83b98671.woff";